import ym from 'react-yandex-metrika';

export const sendUserIdToAnalytics = (id: string) => {
  ym('userParams', {
    UserID: id,
  });
  ym('setUserID', id);
};
